<template>
  <section>
    <banner-top
      ref="bannerTop"
    />
    <div class="container custom-main">
      <slot @event="processEvent" />
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import BannerTop from '@/components/navigation/banner-top'
import globals from '@/plugins/globals.js'
export default {
  name: 'logo-only',
  components: {
    BannerTop
  },
  data() {
    return {
      version: window.config ? window.config.version : '',
      isLoaded: false,
      toggleClass: false
    }
  },
  updated() {
    this.isLoaded = true
  },
  computed: {
    appId() {
      return globals.appId()
    },
    isUK: {
      get() {
        let _isUK = false
        let _appId = globals.appId()
        if (parseInt(_appId) === 1) {
          _isUK = true
        }
        return _isUK
      }
    }
  },
  methods: {
    ...mapActions('auth', ['clearToken']),
    go(where) {
      this.$router.push(`/${where}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-main {
  margin-top: 5px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/logo-only.vue